/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */
import { AggregationTemporality } from './AggregationTemporality';
import { AggregationType } from '../view/AggregationOption';
export const DEFAULT_AGGREGATION_SELECTOR = _instrumentType => {
    return {
        type: AggregationType.DEFAULT,
    };
};
export const DEFAULT_AGGREGATION_TEMPORALITY_SELECTOR = _instrumentType => AggregationTemporality.CUMULATIVE;
//# sourceMappingURL=AggregationSelector.js.map